var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainLayout',[_c('div',{staticClass:"home-content"},[_c('div',{staticClass:"home"},[_c('h1',[_vm._v("404 "+_vm._s(_vm.$t('general_page_not_found')))])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }